import { TableFilters } from 'common-front/src/designSystem/components/tableFilters';
import { TextInput } from 'common-front/src/designSystem/components/textInput';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { usePaginationInfos } from 'common-front/src/hooks/usePaginationInfos';
import { useStateDebounce } from 'common-front/src/hooks/useStateDebounce';
import { Box } from 'common/src/designSystem/components/box';
import { Spacer } from 'common/src/designSystem/components/spacer';
import { Cell } from 'common/src/designSystem/components/table/cell';
import { CellControls } from 'common/src/designSystem/components/table/cellControls';
import { HeaderCell } from 'common/src/designSystem/components/table/headerCell';
import { Row } from 'common/src/designSystem/components/table/row';
import { RowSkeleton } from 'common/src/designSystem/components/table/rowSkeleton';
import { isNonEmptyString } from 'common/src/util/string';
import * as React from 'react';
import { useOrganizationCategoriesCustomFieldsQuery } from '../../generated/graphqlHooks';
import { OrganizationCategoriesCustomFieldsRowDropdown } from './organizationCategoriesCustomFieldsRowDropdown';

export const OrganizationCategoriesCustomFields = () => {
    const {
        translate,
        params: { organizationId }
    } = useHeavent();
    const [name, nameDebounced, setName] = useStateDebounce('');
    const [offset, setOffset] = React.useState(0);
    const { data, isLoading, reload } = useOrganizationCategoriesCustomFieldsQuery({
        organizationId,
        name: isNonEmptyString(nameDebounced) ? nameDebounced : undefined,
        offset
    });
    const { numberOfPages, totalCount } = usePaginationInfos(
        data.organization?.customFieldsCategories
    );

    return (
        <>
            <Spacer height="7" />

            <TableFilters
                filters={
                    <>
                        <Box width={320}>
                            <TextInput
                                icon="magnifying-glass"
                                placeholder={translate('rechercher_une_66722')}
                                value={name}
                                onChange={setName}
                            />
                        </Box>
                    </>
                }
                headerCells={
                    <>
                        <HeaderCell>{translate('nom_de_la_cat_g_03860')}</HeaderCell>
                        <HeaderCell>{translate('nombre_d_utilis_58389')}</HeaderCell>
                        <HeaderCell width={100} />
                    </>
                }
                numberOfPages={numberOfPages}
                offset={offset}
                rows={
                    isLoading ? (
                        <>
                            <RowSkeleton bx={true} />
                            <RowSkeleton bx={true} />
                            <RowSkeleton bx={true} />
                        </>
                    ) : (
                        data.organization.customFieldsCategories.nodes.map((category) => (
                            <Row key={category.id}>
                                <Cell>{category.name}</Cell>
                                <Cell>{category.numberOfCustomFields}</Cell>
                                <CellControls justify="end">
                                    <OrganizationCategoriesCustomFieldsRowDropdown
                                        customFieldCategory={category}
                                        organizationId={organizationId}
                                        reload={reload}
                                    />
                                </CellControls>
                            </Row>
                        ))
                    )
                }
                setOffset={setOffset}
                title={translate('liste_des_cat_g_39450')}
                totalCount={totalCount}
            />
        </>
    );
};
